// src/components/Logo.jsx
import React from 'react';

export default function Logo() {
  return (
    <svg
      width="200"
      height="200"
      viewBox="0 0 400 400"
      xmlns="http://www.w3.org/2000/svg"
    >
      {/* Enhanced defs for more sophisticated gradients and effects */}
      <defs>
        {/* Refined Circle Background Gradient */}
        <linearGradient
          id="circleGradient"
          x1="0%"
          y1="0%"
          x2="100%"
          y2="100%"
        >
          <stop offset="0%" style={{stopColor:"#1a365d", stopOpacity:1}} />
          <stop offset="50%" style={{stopColor:"#234876", stopOpacity:1}} />
          <stop offset="100%" style={{stopColor:"#2b5a8f", stopOpacity:1}} />
        </linearGradient>
        
        {/* Subtle Background Texture */}
        <pattern
          id="subtlePattern"
          width="10"
          height="10"
          patternUnits="userSpaceOnUse"
          patternTransform="rotate(45)"
        >
          <rect width="10" height="10" fill="#ffffff" fillOpacity="0.03" />
          <line x1="0" y1="0" x2="0" y2="10" stroke="#ffffff" strokeWidth="0.5" strokeOpacity="0.05" />
        </pattern>

        {/* Turquoise Diamond Gradient */}
        <linearGradient
          id="diamondGradient"
          x1="0%"
          y1="0%"
          x2="100%"
          y2="100%"
        >
          <stop offset="0%" style={{stopColor:"#40E0D0", stopOpacity:1}} />
          <stop offset="50%" style={{stopColor:"#30C5B5", stopOpacity:0.9}} />
          <stop offset="100%" style={{stopColor:"#20AAA0", stopOpacity:0.8}} />
        </linearGradient>
        
        {/* Diamond Inner Glow */}
        <radialGradient
          id="centerGlow"
          cx="50%"
          cy="50%"
          r="50%"
          fx="50%"
          fy="50%"
        >
          <stop offset="0%" style={{stopColor:"#7FFFD4", stopOpacity:1}} />
          <stop offset="60%" style={{stopColor:"#40E0D0", stopOpacity:0.7}} />
          <stop offset="100%" style={{stopColor:"#20AAA0", stopOpacity:0.2}} />
        </radialGradient>
        
        {/* Turquoise Outer Glow */}
        <filter
          id="turquoiseGlow"
          x="-20%"
          y="-20%"
          width="140%"
          height="140%"
        >
          <feGaussianBlur in="SourceAlpha" stdDeviation="3" />
          <feOffset dx="0" dy="0" result="offsetblur" />
          <feFlood floodColor="#40E0D0" floodOpacity="0.6" result="glowColor" />
          <feComposite in="glowColor" in2="offsetblur" operator="in" result="softGlow" />
          <feMerge>
            <feMergeNode in="softGlow" />
            <feMergeNode in="SourceGraphic" />
          </feMerge>
        </filter>
        
        {/* Enhanced Diamond Inner Glow */}
        <filter
          id="diamondGlow"
          x="-30%"
          y="-30%"
          width="160%"
          height="160%"
        >
          <feGaussianBlur in="SourceAlpha" stdDeviation="8" result="blur" />
          <feComposite in="blur" operator="out" in2="SourceAlpha" result="highlight" />
          <feFlood floodColor="#7FFFD4" floodOpacity="0.9" result="glowColor" />
          <feComposite in="glowColor" in2="highlight" operator="in" result="softGlow" />
          <feComposite in="softGlow" in2="SourceGraphic" operator="over" />
        </filter>
        
        {/* Light Rays Effect */}
        <filter
          id="lightRays"
          x="-20%"
          y="-20%"
          width="140%"
          height="140%"
        >
          <feGaussianBlur in="SourceAlpha" stdDeviation="5" />
          <feOffset dx="0" dy="0" result="offsetblur" />
          <feSpecularLighting 
            in="offsetblur" 
            surfaceScale="5" 
            specularConstant="0.75"
            specularExponent="20" 
            lightingColor="#40E0D0" 
            result="specOut"
          >
            <fePointLight x="200" y="200" z="200" />
          </feSpecularLighting>
          <feComposite in="specOut" in2="SourceAlpha" operator="in" result="specOut" />
          <feComposite in="SourceGraphic" in2="specOut" operator="arithmetic" k1="0" k2="1" k3="1" k4="0" />
        </filter>
        
        {/* Embossed Border Effect */}
        <filter
          id="emboss"
          x="-10%"
          y="-10%"
          width="120%"
          height="120%"
        >
          <feGaussianBlur in="SourceAlpha" stdDeviation="3" result="blur" />
          <feOffset in="blur" dx="2" dy="2" result="offsetBlur" />
          <feSpecularLighting
            in="blur"
            surfaceScale="5"
            specularConstant="1"
            specularExponent="20"
            lightingColor="#ffffff"
            result="specOut"
          >
            <fePointLight x="100" y="100" z="200" />
          </feSpecularLighting>
          <feComposite in="specOut" in2="SourceAlpha" operator="in" result="specOut" />
          <feComposite in="SourceGraphic" in2="specOut" operator="arithmetic" k1="0" k2="1" k3="1" k4="0" result="litPaint" />
          <feMorphology in="SourceAlpha" radius="1" operator="dilate" result="dilated" />
          <feOffset in="dilated" dx="-1" dy="-1" result="offsetDark" />
          <feFlood floodColor="#000000" floodOpacity="0.3" result="darkColor" />
          <feComposite in="darkColor" in2="offsetDark" operator="in" result="darkShadow" />
          <feMerge>
            <feMergeNode in="darkShadow" />
            <feMergeNode in="litPaint" />
          </feMerge>
        </filter>
      </defs>

      {/* Background Circle with Subtle Pattern */}
      <circle cx="200" cy="200" r="190" fill="url(#circleGradient)" />
      <circle cx="200" cy="200" r="190" fill="url(#subtlePattern)" />
      
      {/* Main Circle with Glow - Using ellipse from Inkscape version */}
      <ellipse
        cx="202.72047"
        cy="200"
        rx="172.27953"
        ry="175"
        fill="url(#circleGradient)"
      />
      
      {/* White Embossed Border - ENLARGED - Using transformed circle from Inkscape */}
      <circle
        cx="200"
        cy="200"
        r="187"
        fill="#000080"
        stroke="#ffffff"
        strokeWidth="12"
        filter="url(#emboss)"
        style={{transform: "scale(0.69, 1.015) translate(58.57px, 0.31px)"}}
      />
      
      {/* Refined Subtle Circle Patterns - Using ellipses from Inkscape */}
      <ellipse
        cx="204.76082"
        cy="200"
        rx="150.24496"
        ry="155.00578"
        fill="none"
        stroke="#40E0D0"
        strokeWidth="0.74"
        strokeOpacity="0.2"
      />
      <ellipse
        cx="202.72047"
        cy="200"
        rx="132.28331"
        ry="135.00378"
        fill="none"
        stroke="#40E0D0"
        strokeWidth="0.74"
        strokeOpacity="0.15"
      />
      <circle
        cx="200"
        cy="200"
        r="115"
        fill="none"
        stroke="#40E0D0"
        strokeWidth="0.75"
        strokeOpacity="0.1"
      />
      
      {/* Enhanced Diamond with Light Effects */}
      <path
        d="M200,90 L270,200 L200,310 L130,200 Z"
        fill="url(#diamondGradient)"
        filter="url(#diamondGlow)"
      />
      
      {/* Elegant Diamond Facets */}
      <path d="M200,90 L200,200" fill="none" stroke="#7FFFD4" strokeWidth="0.5" strokeOpacity="0.7" />
      <path d="M200,200 L200,310" fill="none" stroke="#7FFFD4" strokeWidth="0.5" strokeOpacity="0.7" />
      <path d="M130,200 L200,200" fill="none" stroke="#7FFFD4" strokeWidth="0.5" strokeOpacity="0.7" />
      <path d="M200,200 L270,200" fill="none" stroke="#7FFFD4" strokeWidth="0.5" strokeOpacity="0.7" />
      
      {/* Enhanced Diamond Highlight Edges */}
      <path d="M200,90 L130,200" fill="none" stroke="#7FFFD4" strokeWidth="1.5" strokeOpacity="0.9" />
      <path d="M130,200 L200,310" fill="none" stroke="#7FFFD4" strokeWidth="1" strokeOpacity="0.8" />
      
      {/* Diamond Inner Light Reflection */}
      <circle cx="200" cy="200" r="50" fill="url(#centerGlow)" filter="url(#lightRays)" />
      
      {/* Refined Center Point */}
      <circle cx="200" cy="200" r="3" fill="#7FFFD4" fillOpacity="1" />
      
      {/* Subtle Light Flares */}
      <circle cx="170" cy="170" r="2" fill="#40E0D0" fillOpacity="0.9" />
      <circle cx="230" cy="170" r="1.5" fill="#40E0D0" fillOpacity="0.8" />
      <circle cx="185" cy="230" r="1" fill="#40E0D0" fillOpacity="0.7" />
      
      {/* Additional Turquoise Accents */}
      <circle cx="200" cy="200" r="80" fill="none" stroke="#40E0D0" strokeWidth="0.5" strokeOpacity="0.3" />
      <circle
        cx="200"
        cy="200"
        r="100"
        fill="none"
        stroke="#40E0D0"
        strokeWidth="0.5"
        strokeDasharray="2,4"
        strokeOpacity="0.4"
      />
    </svg>
  );
}